export default __webpack_public_path__ + "static/media/beko_white_01.4a7cf330.svg";